import React from "react"
import { useSelector } from "react-redux"
import ChevronRight from "@mui/icons-material/ChevronRight"
import { Button, Dialog, DialogActions, DialogContent } from "@mui/material"

import { RootState } from "../../../store/configureStore"
import { track } from "../../../utils/analytics"
import { useStudentMinutes } from "../../../hooks/useStudentMinutes"
import { useIsInMarket } from "../../../hooks/useIsInMarket"
import { LessonTypeName } from "../../../types"
import PackageSelectWrapper from "../PackageSelectWrapper"

interface Props {
  lessonTypeName: LessonTypeName
  zipcode: string
}

const BuyNowScheduleLater = ({ lessonTypeName, zipcode }: Props) => {
  const {
    firebase: { profile, auth },
  } = useSelector((state: RootState) => state)
  const [isPackageSelectDialogOpen, setIsPackageSelectDialogOpen] =
    React.useState(false)
  const studentCredits = useStudentMinutes(auth.uid)
  const inMarketHook = useIsInMarket(zipcode)
  const isInMarket = inMarketHook.data
  const isRoadTest = lessonTypeName.includes("road-test")
  const type = isRoadTest ? "road test" : "lesson"

  if (!isInMarket || (studentCredits?.drivingMinutesRemaining || 0) > 0) {
    return null
  }

  return (
    <>
      <div style={{ maxWidth: 400, margin: "0 auto", textAlign: "center" }}>
        <h3 style={{ lineHeight: "34px", fontWeight: 600, marginBottom: 0 }}>
          Buy now, schedule later:
        </h3>
        <p style={{ marginTop: 0 }}>
          You can purchase your package now and come back to schedule your{" "}
          {type} any time!
        </p>
        <Button
          variant="contained"
          onClick={() => {
            track("Buy Now Schedule Later Clicked")
            setIsPackageSelectDialogOpen(true)
          }}
          data-cy="skip-schedule-btn"
          disabled={!!profile.isAdmin}
        >
          Choose {type} Package <ChevronRight />
        </Button>
        <div className="separator" style={{ marginTop: 20 }}>
          OR
        </div>
      </div>
      <Dialog
        open={isPackageSelectDialogOpen}
        onClose={() => setIsPackageSelectDialogOpen(false)}
        data-cy="package-select-dialog"
        fullWidth
        maxWidth="md"
      >
        <DialogContent>
          <PackageSelectWrapper
            address={zipcode}
            defaultPackageFilter={lessonTypeName}
            isLesson
            showPackageFilter={false}
            hasSelectedLessonType
            customText={
              <>
                <h3>Step 1: Choose a {type} package</h3>
                <p>You can schedule your {type} after you checkout</p>
              </>
            }
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsPackageSelectDialogOpen(false)}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default BuyNowScheduleLater
